var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vSelect',{attrs:{"options":_vm.seasonOptions,"reduce":label => label.code,"label":"label"},model:{value:(_vm.season),callback:function ($$v) {_vm.season=$$v},expression:"season"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }